export enum TagsActionType {
  SET_TAGS = 'SET_TAGS',
  SEARCH_TAGS = 'SEARCH_TAGS',
  SET_TAGS_PAGINATION = 'SET_TAGS_PAGINATION',
  SET_TAGS_AFTER_SCROLL = 'SET_TAGS_AFTER_SCROLL',
}
